import React from "react";

export default function Answers({ selectedAnswers, removeAnswerByIndex }) {
    if (selectedAnswers.length === 0) {
        return null;
    }

    return (
        <div className="answers">
            <div className="answers-label">You Chose:</div>
            <div className="answers-list">
                {selectedAnswers.map((item, index) => (
                    <div key={index}><button data-size="xs" onClick={() => removeAnswerByIndex(index)} className="button primary">{item.answerText}</button></div>
                ))}
            </div>
        </div>
    );
}

